import React, { createContext, useContext } from 'react'

export interface StepperContextType {
  currentStep: number
  stepsQuantity: number
  isLastStep: boolean
  nextStep: () => void
  previewStep: () => void
  goToStep: (step: number) => void
  goToLastStep: () => void
  setStepsQuantity: React.Dispatch<React.SetStateAction<number>>
}

export const initialState: StepperContextType = {
  currentStep: 1,
  stepsQuantity: 0,
  isLastStep: false,
  nextStep: () => {},
  previewStep: () => {},
  goToStep: () => {},
  goToLastStep: () => {},
  setStepsQuantity: () => {},
}

export const StepperContext = createContext(initialState)

export function useStepperContext() {
  return useContext(StepperContext)
}
